import {useTranslation} from "react-i18next";
import {useHasScope} from "../../../../../config/globalConfig";
import {SCOPE_FINANCE_REFUELLING_EDIT} from "../../../utils/FinanceScope";
import {Accordion, AccordionDetails, AccordionSummary, Box, InputAdornment, TextField, Typography} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function PriceBox({title, base, percentage, total, onChange, editPrice, disabled, hide}: any) {
    const {t} = useTranslation("finance", {keyPrefix: "refuelling"});
    const editabile = useHasScope(SCOPE_FINANCE_REFUELLING_EDIT);

    return (
        <Accordion disabled={disabled} defaultExpanded={true}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon/>}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Typography variant="h5">{title}</Typography>

            </AccordionSummary>
            <AccordionDetails>
                <Box
                    component="form"
                    sx={{
                        "& .MuiTextField-root": {m: 2, width: "30ch"},
                    }}
                    noValidate
                    autoComplete="off"
                >
                    <div>
                        {!hide &&
                            <>
                                <TextField
                                    label={t("price-base")}
                                    variant="outlined"
                                    type="number"
                                    value={base ?? ""}
                                    onChange={editPrice ? onChange : null}
                                    disabled={(!editabile && editPrice) || disabled}
                                    InputLabelProps={{shrink: true}}
                                    InputProps={{
                                        readOnly: !editPrice,
                                        startAdornment: (
                                            <InputAdornment position="start">&euro;</InputAdornment>
                                        ),
                                    }}
                                />

                                {!editPrice && (
                                    <TextField
                                        required
                                        label={t("price-percentage")}
                                        value={percentage ?? ""}
                                        type="number"
                                        variant="outlined"
                                        disabled={!editabile || disabled}
                                        onChange={onChange}
                                        InputLabelProps={{shrink: true}}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">%</InputAdornment>
                                            )
                                        }}
                                    />
                                )}
                            </>
                        }
                        {!editPrice && (
                            <TextField
                                label={t("price-total")}
                                variant="outlined"
                                value={total ?? ""}
                                type="number"
                                disabled={disabled}
                                onChange={onChange}
                                InputLabelProps={{shrink: true}}
                                InputProps={{
                                    readOnly: !hide,
                                    startAdornment: (
                                        <InputAdornment position="start">&euro;</InputAdornment>
                                    ),
                                }}
                            />
                        )}
                    </div>
                </Box>
            </AccordionDetails>
        </Accordion>
    );
}

export default PriceBox;
